const EXPIRATION_FLAG = 'ultrapassou_limite';
const EXPIRATION_MESSAGE = 'tempo_sessao_expirada';
export const SESSION_EXPIRATION_MESSAGE =
  'O tempo da sessão terminou. É necessário ler o QR Code novamente para fazer login.';

const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const toDurationSeconds = (value) => {
  if (value === null || value === undefined || value === '') return null;

  if (typeof value === 'string' && value.includes(':')) {
    const parts = value.split(':').map(Number);
    if (parts.length === 3 && parts.every(Number.isFinite)) {
      return parts[0] * 3600 + parts[1] * 60 + parts[2];
    }
  }

  const number = Number(value);
  // A API envia o limite numérico em minutos (ex.: 3 = 3 minutos).
  return Number.isFinite(number) ? number * 60 : null;
};

// session_control vem da URL como Unix timestamp em segundos.
// O limite numérico da sessão vem em minutos; HH:MM:SS é aceito diretamente.
export const getSessionDeadline = (sessionControl, sessionLimit) => {
  const startedAt = toNumber(sessionControl);
  const limit = toDurationSeconds(sessionLimit);

  // Assim como no backend, limite 0 significa que não há expiração.
  if (startedAt === null || limit === null || limit <= 0) return null;

  const startedAtMilliseconds = startedAt < 1e12 ? startedAt * 1000 : startedAt;
  return startedAtMilliseconds + limit * 1000;
};

export const isSessionExpired = (sessionControl, sessionLimit, now = Date.now()) => {
  const deadline = getSessionDeadline(sessionControl, sessionLimit);
  return deadline !== null && now >= deadline;
};

export const markSessionExpired = () => {
  localStorage.setItem(EXPIRATION_FLAG, 'true');
  localStorage.setItem(EXPIRATION_MESSAGE, 'true');
};

export const clearSessionExpiration = () => {
  localStorage.removeItem(EXPIRATION_FLAG);
  localStorage.removeItem(EXPIRATION_MESSAGE);
};

export const getSessionExpirationMessage = () => SESSION_EXPIRATION_MESSAGE;

export const redirectToQrReader = () => {
  markSessionExpired();
  window.location.replace('/?session_expired=true');
};

